// Asegúrate de que GSAP y ScrollTrigger estén cargados.
// En Shopify, puedes incluirlos en tu theme.liquid o directamente en este archivo JS
// si aún no están globalmente disponibles.
// Si ya están en theme.liquid, puedes omitir la importación aquí.
// Ejemplo de importación si no están:
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', function() {
    // Solo registra el plugin si no ha sido registrado previamente
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && !ScrollTrigger.isRegistered) {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Animación para la imagen de la sección intro-marca
    // Se dispara cuando el trigger ('#intro-marca-trigger') entra en el 60% de la ventana
    const introTl = gsap.timeline({ 
        scrollTrigger: { 
            trigger: '#intro-marca-trigger', 
            start: 'top 60%', 
            toggleActions: 'play none none none' // Reproducir una vez al entrar
        } 
    });

    // Anima el clipPath de la imagen para que aparezca
    introTl.to('.intro-image-wrapper', { 
        clipPath: 'inset(0 0% 0 0)', 
        duration: 1.5, 
        ease: 'power4.inOut' 
    });

    // Anima el contenido de texto (h2, p, a) para que aparezca desde abajo con un stagger
    introTl.from('.intro-content > *', { 
        opacity: 0, 
        y: 30, 
        stagger: 0.2, 
        duration: 1, 
        ease: 'power3.out' 
    }, '-=1'); // Empieza 1 segundo antes de que termine la animación anterior
});